import { buildContractPath } from "./api/contract-client.js";

export const INTELLIGENCE_TIMEOUT_MS = 20000;

export function buildGetAiIncidentsPath(query = {}) {
  return buildContractPath("get__ai_incidents", { query });
}

export function buildGetAiIncidentPath(itemId) {
  return buildContractPath("get__ai_incidents_p", { pathParams: [itemId] });
}

export function buildPostAiAnalyzePath() {
  return buildContractPath("post__ai_analyze");
}

export function buildPostAiApprovePath(incidentId) {
  return buildContractPath("post__ai_incidents_p_approve", { pathParams: [incidentId] });
}

/** Wave G3b-c — map frame ask (contract-first). */
export function buildPostAiVisionAskPath(incidentId) {
  return buildContractPath("post__ai_incidents_p_vision_ask", { pathParams: [incidentId] });
}

export function buildPostAiVisionRefreshPath(incidentId) {
  return buildContractPath("post__ai_incidents_p_vision_refresh", { pathParams: [incidentId] });
}

export function buildGetAiSettingsPath() {
  return buildContractPath("get__ai_settings");
}

export function buildPatchAiSettingsPath() {
  return buildContractPath("patch__ai_settings");
}

export function buildGetPredictiveMaintenancePath() {
  return buildContractPath("get__predictive_maintenance");
}
